<div class="select-bar" [formGroup]="formGroup">
  <div class="select-bar-item">
    <label>Project name</label>
    <p-select
      formControlName="project"
      [showClear]="true"
      [options]="projects()"
      placeholder="Select a project"
      fluid
      inputId="project-ac"
    />
  </div>

  <div class="select-bar-item">
    <label>Message type</label>
    <p-select
      formControlName="type"
      [options]="types()"
      [showClear]="true"
      placeholder="Select a message type"
      fluid
      inputId="type-ac"
    />
  </div>

  <div class="select-bar-item">
    <label>Service name</label>
    <p-select
      formControlName="service"
      [options]="services()"
      [showClear]="true"
      placeholder="Select a service"
      fluid
      inputId="service-ac"
    />
  </div>

  <div class="select-bar-item">
    <label>Box ID</label>
    <input
      pInputText
      type="text"
      formControlName="boxId"
      placeholder="Box ID"
      fluid
    />
  </div>

  <div class="select-bar-item">
    <label>Folder ID</label>
    <input
      pInputText
      type="text"
      formControlName="folderId"
      placeholder="Folder ID"
      fluid
    />
  </div>

  <div class="select-bar-item">
    <label>Search message</label>
    <textarea
      pTextarea
      rows="3"
      placeholder="Message"
      formControlName="message"
      fluid
    ></textarea>
  </div>

  <div class="select-bar-item">
    <label>Start datetime</label>
    <div class="date-input-container">
      <p-datepicker
        [showTime]="true"
        [showSeconds]="false"
        [showIcon]="true"
        [showClear]="true"
        hourFormat="24"
        formControlName="dateStart"
        dateFormat="dd/mm/yy"
        fluid
      >
      </p-datepicker>
    </div>
  </div>

  <div class="select-bar-item">
    <label>End datetime</label>
    <div class="date-input-container">
      <p-datepicker
        [showTime]="true"
        [showSeconds]="false"
        [showIcon]="true"
        [showClear]="true"
        hourFormat="24"
        formControlName="dateEnd"
        dateFormat="dd/mm/yy"
        fluid
      >
      </p-datepicker>
    </div>
  </div>
</div>
